/* eslint-disable */
import React, { Component } from "react";
import {
  List,
  Button,
  TransitionablePortal,
  Header,
  Icon,
  Modal,
  Image,
  Popup,
  Segment,
  Divider,
} from "semantic-ui-react";

class PVInfoContainer extends Component {
  constructor(props) {
    super(props);
    this.state = {
        showModal: false,
        imagePath: undefined,
        generalInfo: []
    };
  }
  componentWillMount() {
      this.props.pvDetails.property_visit_rooms.length > 0 ? this.parseRooms(this.props.pvDetails.property_visit_rooms) : null;
      this.props.pvDetails.additional_visit_images.length > 0 ? this.parseAdditionalImages( this.props.pvDetails.additional_visit_images) : null;
    } 

parseRooms = (rooms) => {
  rooms.map(room => {
    let roomTitle = room.room_name
    let images = []
    room.property_visit_images.length > 0 ? room.property_visit_images.map(image => { images.push({ ...image, notes: [{ header: roomTitle, info: room.room_description }] }) }) : null
    this.addToGeneralInfo({ name: roomTitle, images: images })
  })
}

parseAdditionalImages = (additional_images) =>{
  let images = []
  additional_images.map( (image,id) =>{
    images.push({ ...image,notes: [{ header: "Additional Image", info: `# ${id + 1}` }]})
  })
  this.addToGeneralInfo({name:"Additional Images", images:images})
}
    addToGeneralInfo = (section) => {
        var newState = { ...this.state }
        newState.generalInfo.push(section)
        section.images.map(image => { this.props.addToImagesList(image) })
        this.setState(...newState)
                }
              

    render() {
 
    return (
      <React.Fragment>
        <div className="nested-segment">
                <Header className="nested-segment" as="h2" attached="top"><Icon color="blue" name="list" />
                    <Header.Content>Room Photos</Header.Content> 
          </Header>
          <Segment attached className="nested-segment">
            {this.state.generalInfo ? this.state.generalInfo.map((section) => {
               return <React.Fragment key={section.name}>
                  <div className="nested-segment">
                    <Segment secondary attached="top">
                      <Header as="h3"><Icon color="grey" name="photo" /> {section.name}</Header>
                    </Segment>
                    <Segment attached>
                      <Image.Group size="small">
                                  {section.images ? section.images.map((image) => {
                                          return (image.image_path_hq?<Popup
                                              key={image.id}
                                              trigger={
                                                  <Image
                                                      style={{ cursor: "pointer" }}
                                                      className="grow"
                                                      onClick={() => {this.props.setCurrentImage(image)
                                                      }}
                                                      rounded
                                                      src={image.image_path_hq}
                                                      target="_blank"
                                                  />}
                                              content={<List divided>
                                                  {image.notes? image.notes.map((note) => {
                                                      return <List.Item key={note.info}>
                                                          <List.Content>
                                                              <List.Header
                                                                  style={{ color: "#4183c4" }}>
                                                                  {note.header}
                                                              </List.Header>
                                                              <List.Description>
                                                                  {note.info}
                                                              </List.Description>
                                                          </List.Content>
                                                      </List.Item>
                                                  }):null}</List>}
                                          />:null
                                          )
                                  }) : null}
                      </Image.Group>
                    </Segment>
                  </div> <Divider section />
                </React.Fragment>
            }):null}
          </Segment>
        </div>
        <Divider section />
      </React.Fragment>
    );
  }
}

export default PVInfoContainer;



// WEBPACK FOOTER //
// ./src/views/property_visits/pv_report_viewer/pv_info_container.js